export default __webpack_public_path__ + "static/media/backgroundImage.933fb678.png";